import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import axios from "axios";
import { getNavProps } from "../App";
import PhoneInput from "react-phone-number-input";
import { translations } from "../translations";
import TextField from "@mui/material/TextField";
import "./RegisterPage.css";
import { useSnackbar } from "notistack";

const RegisterPage = ({ fetchUserRequestStats, handleClear, siteLanguage }) => {
  const { enqueueSnackbar } = useSnackbar();
  const countries = ["US", "IN", "CA", "GB", "AU"];

  axios.defaults.withCredentials = true;

  const [phone, setPhone] = useState("");
  const [verificationCode, setVerificationCode] = useState("");
  const [isPhoneSubmitted, setPhoneSubmitted] = useState(false);
  const [error, setError] = useState("");

  const handlePhoneChange = (value) => setPhone(value);
  const handleVerificationCodeChange = (event) =>
    setVerificationCode(event.target.value);

  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const navProps = getNavProps();

    if (!isPhoneSubmitted) {
      enqueueSnackbar("Verification code sent!", { variant: "info" });
      // Send phone number to server for verification
      try {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/api/start-verification`,
          {
            phoneNumber: phone,
          }
        );
        setPhoneSubmitted(true);
        setError(""); // reset error
      } catch (error) {
        // handle error
        console.error(error);
      }
    } else {
      // Verify the code
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/check-verification`,
          {
            phoneNumber: phone,
            otpCode: verificationCode,
            ...navProps,
          }
        );

        if (response.status === 201) {
          console.log("Success:", response.data);
          // fetchUserRequestStats();
          // handleClear();
          window.location.href = "/";
        } else {
          enqueueSnackbar("Incorrect code...", { variant: "error" });
          setError("Verification code is incorrect. Please try again.");
        }
      } catch (error) {
        setError("Verification code is incorrect. Please try again.");
        console.error("Error:", error);
      }
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography align="center" component="h1" variant="h5">
          {isPhoneSubmitted
            ? "Check your phone and enter the Verification Code"
            : "Enter Your Phone Number"}
        </Typography>
        <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 3 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              {!isPhoneSubmitted ? (
                <div className="phoneInputWrapper">
                  <PhoneInput
                    withCountryCallingCode
                    international
                    defaultCountry="US"
                    countries={countries}
                    value={phone}
                    onChange={handlePhoneChange}
                  />
                </div>
              ) : (
                <TextField
                  className="TextField"
                  required
                  fullWidth
                  name="verificationCode"
                  label="Verification Code"
                  type="text"
                  id="verificationCode"
                  autoComplete="current-verificationCode"
                  value={verificationCode}
                  onChange={handleVerificationCodeChange}
                />
              )}
            </Grid>
          </Grid>
          {error && <Typography color="error">{error}</Typography>}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
          >
            {isPhoneSubmitted ? "Verify Code" : "Register"}
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default RegisterPage;
